import React, { Component } from 'react';
import ImageUploader from './ImageUploader'
import { storeProfileImage } from '../../../redux/actions/user_actions'
import { connect } from 'react-redux'
class Settings extends Component {

    setProfilePicture = (image) => {
        this.props.storeProfileImage(this.props.currentUser._id, image)
    }

    render() {
        return (
            <div className="settings-container flex-column max-width">
                <div id="settings-content-container" className="flex-centered max-size">
                    <div className="flex-column-center shadow" id="settings-content">
                        <h3 className="settings-header">Account Settings</h3>
                        <div className="flex-justify-center max-size" style={{ alignItems: "center" }}>
                            <ImageUploader userId={this.props.currentUser._id} profileImage={this.props.currentUser.image} propsItem={this.props} setProfilePicture={this.setProfilePicture}/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mSTP = state => ({
    currentUser: state.session.user
});

const mDTP = dispatch => ({
    storeProfileImage: (userId, profileImage) => dispatch(storeProfileImage(userId, profileImage))
});

export default connect(mSTP, mDTP)(Settings)